import { Box, Button, Stack, Tooltip } from '@atgfr8/atg-ui-tailwind';
import { carrierUrls } from '@constants/urls';
import { load } from '@store/orders/selectors';
import { OpenInNewIcon } from '@atgfr8/icons';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import { createEffect, createSignal, on, Show } from 'solid-js';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { isOrderStoreDirty } from '@utils/utils';

import ShippingLabelButton from './ShippingLabelButton';

type PropsT = {
  load: ILoadEditViewModel;
  tabIndex: number;
  isCarrierSelected: boolean;
  isCapacityFinderEnabled: boolean;
};

export const CarrierDetailActionButtons = (props: PropsT) => {
  const [isBillOfLadingDisabled, setIsBillOfLadingDisabled] =
    createSignal<boolean>(Boolean(props.load.carrierId));

  createEffect(
    on(
      () => props.load.carrierId,
      () => {
        if (
          Boolean(props.load.operationType) &&
          (props.load.operationType === 'Insert' ||
            props.load.operationType === 'Update')
        ) {
          setIsBillOfLadingDisabled(
            !isOrderStoreDirty() && !Boolean(props.load.isCarrierDirty),
          );
        }
      },
    ),
  );

  return (
    <Stack direction="row">
      <Show when={Boolean(props.load.carrierId) && Boolean(props.load.id)}>
        <Stack
          direction="row"
          gap={0.5}
          alignItems="center"
          justifyContent="flex-end"
          mb="-5px"
          flex={1}
          flexWrap="wrap"
        >
          <Box>
            <Button
              variant="contained"
              size="sm"
              dataTestId={formatDataTestId('Rate Confirmation', 'button')}
              class="text-armstrong-sm! bg-white! border-[#123B50]! !border font !rounded text-[#123B50]!
              disabled:opacity-50! disabled:cursor-not-allowed! disabled:bg-[#f5f5f5]! disabled:text-[#9e9e9e]! disabled:border-[#e0e0e0]!"
              startIcon={<OpenInNewIcon size={20} />}
              sx={{
                border: '1px solid',
              }}
              disabled={
                (load()?.forceCarrierChange || load()?.forceCustomerChange) ??
                false
              }
              onClick={() =>
                window.open(
                  carrierUrls.rateConfirmation(props.load.id),
                  '_blank',
                )
              }
            >
              Rate Confirmation
            </Button>
          </Box>
          <Show when={props.load.mode === 'LTL'}>
            <Box>
              <ShippingLabelButton load={props.load} />
            </Box>
          </Show>
          <Box>
            <Show
              when={isBillOfLadingDisabled()}
              fallback={
                <Tooltip
                  title={
                    'Please save the load prior to accessing the Bill of Lading'
                  }
                  placement="left"
                  class="z-50"
                  dataTestId="bill-of-lading-tooltip"
                >
                  <Button
                    disabled={true}
                    dataTestId={formatDataTestId('Bill of Lading', 'button')}
                  >
                    Bill of Lading
                  </Button>
                </Tooltip>
              }
            >
              <Button
                variant="contained"
                size="sm"
                class="text-armstrong-sm! bg-white! border-[#123B50]! border! font rounded-sm! text-[#123B50]!"
                startIcon={<OpenInNewIcon size={20} />}
                sx={{
                  border: '1px solid',
                }}
                onClick={() =>
                  window.open(carrierUrls.billOfLading(props.load.id), '_blank')
                }
                dataTestId={formatDataTestId('Bill of Lading', 'button')}
              >
                Bill of Lading
              </Button>
            </Show>
          </Box>
        </Stack>
      </Show>
    </Stack>
  );
};
